import { render, staticRenderFns } from "./ChaileaseSalesLayout.vue?vue&type=template&id=6dc80b88&"
var script = {}
import style0 from "./ChaileaseSalesLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports